import React from 'react';
import { Box, Typography } from '@mui/material';
import BaseDialog from 'common/components/base-dialog';
import EnvelopOpen from 'assets/images/icons/envelop-open.svg';
import { colors } from 'common/constants';
import { useTranslation } from 'react-i18next';
interface AccountNotActivatedDialogProps {
    open: boolean;
    onClose: () => void;
}
const AccountNotActivatedDialog: React.FC<AccountNotActivatedDialogProps> = ({
    open,
    onClose,
}) => {
    const { t } = useTranslation();
    return (
        <BaseDialog
            open={open}
            footer={false}
            maxWidth={'xl'}
            onClose={onClose}
            sxContent={{
                padding: '50px 90px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: 2,
                }}
            >
                <img
                    src={EnvelopOpen}
                    alt="icon"
                    style={{
                        marginBottom: '60px',
                        marginTop: '20px',
                    }}
                />
                <Typography
                    component={'p'}
                    sx={{
                        fontSize: '28px',
                        lineHeight: '34px',
                        fontWeight: '700',
                        color: `${colors.main}`,
                    }}
                >
                    {t('your.account.is.registered.but.not.activated')}
                    <br />
                    {t('please.check.your.email.to.activate.your.account')}
                </Typography>
            </Box>
        </BaseDialog>
    );
};

export default AccountNotActivatedDialog;
